<script setup lang="ts">
import type { IParagraphEntry } from "~/models/IUserEntry";

defineProps<{
  entry: IParagraphEntry;
}>();

defineEmits<{
  delete: [entry: IParagraphEntry];
}>();

const { hoverToDeleteItem } = storeToRefs(useContextMenuHoverDelete());
</script>

<template>
  <ContextButton
    @click="$emit('delete', entry)"
    @mouseenter="hoverToDeleteItem = entry.id"
    @mouseleave="hoverToDeleteItem = null"
  >
    {{ $t("entries.deletion.title", { type: entry.type }) }}
  </ContextButton>
</template>
